/* angular:styles/component:css;d44976c3b1c3abd320a833a6c711c98fa0fecd99fd2ee3b6b9e5f97c68abce14;/src/src/app/edge/settings/app/formly/formly-text.ts */
.warning {
  color: red;
}
/*# sourceMappingURL=formly-text.css.map */
